import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const Testimonials = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 60 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
  };

  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const testimonials = [
    {
      quote:
        "When we purchased our office in Sandhurst it was tired and dated, the layout was transformed by Dominic and his team, into a bright, open plan and practical office. He was patient with us throughout, despite some changes along the way and delivered on time and within budget. We could not recommend him more highly.",
      author: "Rosie France",
      role: "Directors' Assistant & National Branch Officer",
      company: "Chard Robinson / Encore Head Office Fit-out",
    },
    {
      quote:
        "Dominic, The office looks great, everyone is thoroughly pleased with the results. Thanks for your efforts and hard work. As I said before its been a pleasure working with you, if only there were more contractors about like you when I was in the game.",
      author: "Ben Lee",
      role: "Head of Ops",
      company: "Anglo-Tunisian Oil & Gas (ATOG) Office Fit-out",
    },
    {
      quote:
        "Dominic at Sandhurst interiors was highly recommended to me for a very bespoke office refurbishment requirement to our grade-listed offices in Hampshire. He did not fail to disappoint. He took all of our requirements on board, found resolution to the challenges faced in a listed property and delivered the project to the timescale agreed. The quality and finish of work was done to perfection and Dominic was very mindful on ensuring the finished product was to the client's satisfaction and expectations. Thank you Sandhurst Interiors – we will certainly reach out to you again for our next refurbishment project.",
      author: "Claire Cook",
      role: "Office Manager",
      company: "AvenueBio Consulting Limited / Avenue Bio Office Fit-out",
    },
    {
      quote:
        "Dominic and his team did a fantastic job of our office refurbishment, transforming our space to suit our new hybrid working needs. Nothing was too much trouble and their patience, can-do attitude and sense of humour was much appreciated throughout the work.",
      author: "Sarah Smith",
      role: "CEO",
      company: "Soak & Sleep Head Office Fit-out",
    },
    {
      quote:
        "Dominic is hugely experienced, which means he is a problem solver, he offers advice where needed, but similarly will try to make your ideas work, where possible. He has a team of his own and he only uses subcontractors he has worked with before and knows he can trust. If you ask Dominic to get a job done, he will and always to budget. He does not cut corners and therefore the standard of work is of the highest quality. I have no hesitation in recommending Dominic and his team at Sandhurst.",
      author: "Steve Mellstrom",
      role: "Managing Partner",
      company: "Glen House Estates",
    },
    {
      quote:
        "I came across Sandhurst Interiors via a Google search when looking for a commercial interiors company to undertake our office refit. I was a bit apprehensive about what to expect, but as soon as I met Dominic that all changed. He was very professional and had some great ideas. We are very pleased with every aspect of the refit, from the planning through to completion including the aftercare service which has been impeccable and included additional work that was carried out at our convenience. I would, and have, recommended Sandhurst Interiors without hesitation. Thank you",
      author: "Jo Musialek",
      role: "EA to the CEO",
      company: "Lumina Learning",
    },
    {
      quote:
        "We recently used Sandhurst Interiors to refit a previously furnished office for our growing workforce to move into. We chose them because, not only was their quote very reasonable, but from the onset they provided a lot more than just a refit service. Dominic's knowledge and advice was invaluable to us. It gave us great comfort to have someone on the project who really knew what they were doing. We could concentrate on running our business safe in the knowledge that he was getting on with the job. Everything was completed in a timely fashion and within budget with no nasty surprises. We would not hesitate to recommend Sandhurst Interiors",
      author: "Debra Roberts",
      role: "Finance Director",
      company: "Aspire Pharma",
    },
    {
      quote:
        "We have just finished working with Sandhurst Interiors on a new fit out for our new office. Dominic has been entirely professional, helpful and hard-working from the start. Dominic made sure that the quote he provided was within our budget and once the project began, he took control from the start to the finish, leaving us with nothing to worry about. Dominic ensured he kept us informed of timescales and any problems which arose (and even fixed our boiler for us). We are delighted with the finished office and the clients have all commented on how smart the new look is. We wouldn't hesitate to use Sandhurst Interiors again for any new projects.",
      author: "Rachel Watson",
      role: "",
      company: "Watson Thomas Solicitors",
    },
    {
      quote:
        "We have now had the opportunity of working with Sandhurst Interiors over many years on multiple projects. We have always found their level of customer service to be second to none. The quality of the work they carry out is excellent and we would have no hesitation in recommending Dominic and his team to anybody. We look forward to working with Sandhurst Interiors on many more projects in 2021.",
      author: "Daniel Cain",
      role: "Sales / Business Development Manager",
      company: "",
    },
    {
      quote:
        "Sandhurst Interiors were recommended to us when we were looking for someone to carry out a lot of painting and refurbishment work of our school in Bracknell Forest. The work needed to be scheduled to minimise any disruption to school. This included working late night and working over the weekend. Dominic was very professional and was always polite and helpful. Their work was always to an excellent standard; clean, within budget and on time. We have since used Dominic again to refurbish some additional classrooms. I would recommend Dominic without hesitation",
      author: "Michael Dillon",
      role: "B.Ed (Hons) MA, Headteacher",
      company: "Birch Hill Primary School",
    },
    {
      quote:
        "We found Sandhurst Interiors at midnight one frantic evening over Christmas as we were renovating a dated office block in Hook, Hampshire, whilst turning it into a Business Centre. One licensee required 3 extra offices and everywhere was shut/closing down before December 25th. We met Dominic the next day and the plans/quote arrived 24 hours later and once agreed the job was completed on time between Christmas and New Year, and everything was left neat and tidy afterwards. Always going above and beyond to accommodate our requirements/timings and planning around obstacles We recommend Sandhurst Interiors 100%.",
      author: "Sharon Thomas",
      role: "Business Centre Manager",
      company: "Landmark House",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="initial"
            animate="animate"
            variants={staggerContainer}
            className="text-center"
          >
            <motion.h1
              variants={fadeInUp}
              className="text-4xl md:text-5xl font-bold text-gray-900 mb-6"
            >
              What Our Clients Say
            </motion.h1>
            <motion.p
              variants={fadeInUp}
              className="text-xl text-gray-600 max-w-3xl mx-auto"
            >
              Don't just take our word for it—hear from our satisfied clients
            </motion.p>
          </motion.div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="section-padding">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.1,
                }}
                className="card flex flex-col h-full"
              >
                <div className="flex items-start mb-4">
                  <Quote className="w-8 h-8 text-primary-500 flex-shrink-0 mt-1" />
                </div>
                <p className="text-gray-700 mb-6 flex-grow italic">
                  "{testimonial.quote}"
                </p>
                <div className="border-t border-gray-200 pt-4">
                  <p className="font-semibold text-gray-900">
                    {testimonial.author}
                  </p>
                  {testimonial.role && (
                    <p className="text-sm text-gray-600">{testimonial.role}</p>
                  )}
                  {testimonial.company && (
                    <p className="text-sm text-primary-600 font-medium mt-1">
                      {testimonial.company}
                    </p>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-primary-600">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Ready to improve your workspace?
            </h2>
            <p className="text-xl text-primary-100 mb-8">
              Speak with our team today about transforming your office,
              warehouse or facility.
            </p>
            <div className="flex justify-center">
              <Link
                to="/contact#contact-form"
                onClick={() => {
                  sessionStorage.setItem("scrollToContactForm", "true");
                }}
                className="border-2 border-white text-white hover:bg-white hover:text-primary-600 font-medium py-3 px-8 rounded-lg transition-all duration-200 text-center"
              >
                Get in Touch
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
